import { render, staticRenderFns } from "./second_cloudBooth.vue?vue&type=template&id=119935c6&scoped=true&"
import script from "./second_cloudBooth.vue?vue&type=script&lang=js&"
export * from "./second_cloudBooth.vue?vue&type=script&lang=js&"
import style0 from "./second_cloudBooth.vue?vue&type=style&index=0&id=119935c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119935c6",
  null
  
)

export default component.exports